goog.module('yext.storm.PixelTracking');
goog.module.declareLegacyNamespace();

/**
 * This is used to track storm users and/or employees logged into storm for answers analytics
 *
 * @public
 */
function init() {
  loadImage('https://realtimeanalytics.yext.com/t', yext.businessId, yext.employeeId, yext.userId);
}

/**
 * @private
 * @param {string} src
 * @param {number} businessId
 * @param {number} employeeId
 * @param {number} userId
 */
let loadImage = function(src, businessId, employeeId, userId) {
  var img = document.createElement('img');

  img.src = `${src}?b=${businessId}&e=${employeeId}&u=${userId}&ver=${cacheBuster()}`;
  img.width = '0';
  img.height = '0';
  img.style.setProperty('width', '0', 'important');
  img.style.setProperty('height', '0', 'important');
  img.style.position = 'absolute';
  img.alt = '';

  document.body.appendChild(img);
};

/**
 * @private
 * @return {number} random number
 */
let cacheBuster = function() {
  return Date.now() + Math.floor(Math.random() * 1000);
};

exports = {
  init,
};
